<template>
  <section
    class="flex flex-col-reverse gap-4 md:grid md:grid-cols-2 lg:w-auto lg:mx-auto lg:p-5"
  >
    <!-- Sol İçerik -->
    <div
      class="mx-auto flex max-w-2xl flex-col justify-center gap-5 px-6 py-6 md:px-8 md:py-12 xl:scale-[1.15]"
    >
      <!-- Vurgu Çizgisi -->
      <div class="mx-auto w-fit md:mx-0">
        <div class="bg-accent h-0.5 w-20 rounded-sm" />
      </div>

      <!-- Başlık -->
      <h1 class="text-center text-2xl font-bold md:text-start md:text-3xl">
        {{ $t("onetoone.title") }}
      </h1>

      <!-- Açıklama -->
      <p class="leading-8 text-gray-300">
        <strong>{{ $t("onetoone.brand") }}</strong
        >{{ $t("onetoone.description2") }}
        <br />
        <span class="italic text-sm text-gray-400">
          {{ $t("onetoone.note") }}
        </span>
      </p>

      <!-- Özellikler -->
      <ul class="space-y-2">
        <li class="flex items-center gap-3">
          <div class="bg-white flex size-12 rounded-full border border-none">
            <img
              class="mx-auto text-white"
              height="40"
              alt="Eğitim"
              src="/assets/images/2028205.svg"
            />
          </div>
          <span>{{ $t("onetoone.features.terrain") }}</span>
        </li>
        <li class="flex items-center gap-3">
          <div class="bg-white flex size-12 rounded-full border p-2">
            <img
              class="mx-auto h-full"
              height="40"
              alt="Hızlı Planlama"
              src="/assets/images/calendar-clock.svg"
            />
          </div>
          <span>{{ $t("onetoone.features.planning") }}</span>
        </li>
        <li class="flex items-center gap-3">
          <div class="bg-white flex size-12 rounded-full border p-2">
            <img
              class="mx-auto h-full"
              height="40"
              alt="Yerel Eğitim"
              src="/assets/images/map-pin.svg"
            />
          </div>
          <span>{{ $t("onetoone.features.location") }}</span>
        </li>
      </ul>

      <!-- CTA Butonu -->
      <NuxtLink
        to="/training/onetoone"
        class="mt-4 px-4 md:px-4 lg:px-5 xl:px-3 2xl:px-5 py-3 text-sm md:text-base rounded-full bg-[#3DCBB1] border border-[#3DCBB1] hover:opacity-80 flex items-center gap-2"
      >
        {{ $t("onetoone.cta") }}
      </NuxtLink>
    </div>

    <!-- Sağ Görsel -->
    <img
      class="h-full min-h-[275px] w-full rounded-bl-[50px] object-cover"
      alt="MEM22 birebir eğitim"
      src="/onetoone.jpg"
      loading="eager"
      decoding="async"
    />
  </section>
</template>

<script setup lang="ts"></script>
